import React, {useEffect, useState} from "react";
import {
    MDBAlert,
    MDBCard,
    MDBCol, MDBIcon,
    MDBRow
} from "mdbreact";
import {Alert, Avatar, Tooltip, Modal, List} from 'antd';
import SideBar from "../Navbars/SideBar";
import {Card, Layout} from "antd";
import NavBar from "../Navbars/NavBar";
import { MessageOutlined, LikeOutlined, StarOutlined } from '@ant-design/icons';
import {
    Button,
    Dialog,
    SearchInput,
} from "evergreen-ui";
import {Text} from "react-font";
import Firebase from "../../Firebase";
import Map from "../Map";
import CreateOutletModal from "../Modals/Outlet/CreateOutletModal";
import EditOutletModal from "../Modals/Outlet/EditOutletModal";
import {useCollection} from "react-firebase-hooks/firestore";
import ViewOutlet from "../Modals/Outlet/ViewOutlet";

const moment = require("moment");

const { Content } = Layout;
const db = Firebase.firestore();
const storageRef = Firebase.storage().ref("System/Outlets");

const Outlets = (props) => {

    const [checkedData, setCheckedData] = useState(true);
    const callback = (data) => {
        setCheckedData(data);
    }
    const [color, setColor] = useState("info");
    const [message, setMessage] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [outletSnapshot, loading] = useCollection(
        db.collection('outlets'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [outlets, setOutlets] = useState([]);
    const [createModal, setCreateModal] = useState(false);
    const [geoArray, setGeoArray] = useState([]);
    const [selectedOutlet, setSelectedOutlet] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [userArray, setUserArray] = useState([]);
    const [users] = useCollection(
        db.collection('users'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [editModal, setEditModal] = useState(false);
    const [editOutlet, setEditOutlet] = useState(null);
    const [filterGeoArray, setFilterGeoArray] = useState([]);
    const [dataArray, setDataArray] = useState([]);


    const toggle = () => {
        setIsModalVisible(!isModalVisible);
    }

    useEffect(() => {
        if(users){
            var array = [];
            users.docs.map(user => {
                array.push(user.data());
            });
            setUserArray(array);
        }
        var geoLocArray = [];
        if(outletSnapshot){
            var outletArray = [];
            outletSnapshot.docs.map((snapshot) => {
                var product = snapshot.data();
                outletArray.push(product);
            });
            setOutlets([...outletArray]);
            
            const sortedArray = outletArray.sort((a,b) => new moment(b.dateCreated).format('YYYYMMDD') - new moment(a.dateCreated).format('YYYYMMDD'))
            setDataArray(sortedArray);
            outletArray.map((outlet) => {
                var urlArray = []
                storageRef.child(outlet.outletID).listAll()
                    .then((res) => {
                        res.items.forEach((itemRef) => {
                            // All the items under listRef.
                            itemRef.getDownloadURL().then((url) => {
                                urlArray.push(url);
                            })
                        });
                    }).catch((error) => {
                    // Uh-oh, an error occurred!
                });
                outlet.urls = urlArray;
                geoLocArray.push(
                    {
                        "type": "Feature",
                        "properties": {
                            "name": outlet.name,
                            "location" : outlet.location,
                            "iconSize": [60, 60],
                            "outletID" : outlet.outletID,
                            "longitude" : outlet.coordinates.longitude,
                            "latitude" : outlet.coordinates.latitude,
                            "conEmail" : outlet.contactPerson.email,
                            "conName" : outlet.contactPerson.name,
                            "conPhone" : outlet.contactPerson.phone,
                            "notes" : outlet.feedbackNotes,
                            "createdBy" : outlet.createdByID,
                            "dateCreated" : outlet.dateCreated,
                            "urls" : outlet.urls
                        },

                        "geometry": {
                            "type": "Point",
                            "coordinates": [outlet.coordinates.longitude, outlet.coordinates.latitude]
                        }
                    })

            })

            setGeoArray([...geoLocArray]);
            setFilterGeoArray([...geoLocArray])

        }
        
        
    }, [outletSnapshot, props.users, users])

    const handleSearch  = searchText => {
        const filteredEvents = outlets.filter(({ name, location }) => {
            name = name.toLowerCase();
            location = location.toLowerCase();
            return name.includes(searchText) || location.includes(searchText) ;
        });

        const filteredGeos = filterGeoArray.filter(({ properties }) => {
            properties.name = properties.name.toLowerCase();
            properties.location = properties.location.toLowerCase();
            return properties.name.includes(searchText) || properties.location.includes(searchText) ;
        })

        setGeoArray(filteredGeos);
        setDataArray(filteredEvents);
    }

    const deleteOutlet = (outletID) => {

        db.collection("outlets").doc(outletID).delete()
            .then(() => {
                setMessage("Outlet deleted successfully");
                setColor("success");
                setShowAlert(true);
                setTimeout(() => {
                    setShowAlert(false);
                }, 3000);

                storageRef.child(outletID).listAll()
                    .then((res) => {
                        res.items.forEach((itemRef) => {
                            itemRef.delete().then(() => {
                                console.log("deleted");
                            }).catch(() => {
                            })
                        });
                    }).then(() => {
                }).catch((error) => {
                });
            })
            .catch((error) => {
                setMessage("Unable to delete outlet occurred :: " + error.message);
                setColor("danger");
                setShowAlert(true);
            });

    }

    const showViewModal = (outlet) => {
        setSelectedOutlet(outlet);
        setIsModalVisible(!isModalVisible);
    };

    const showEditModal = (outlet) => {
        var prodObject = outlet.products;
        var productArray = Object.values(prodObject);
        var prodArray = [];
        productArray.map((item) => {
            prodArray.push(item.productID);
        });
        outlet.products = prodArray;
        setEditOutlet(outlet);
        setEditModal(true);
    }


    return (
        <div>
            <Layout style={{width: "100vw"}}>
                <SideBar checked={checkedData}/>
                <Layout className="site-layout">
                    <NavBar token={"token"} checkBack={callback}/>
                    <Content
                        className="site-layout-background"
                        style={{ margin: '10px 16px 15px'}}
                    >
                        <MDBRow className="w-100">
                            <MDBCol md={12}>

                                <Dialog
                                    isShown={createModal}
                                    title="Create New Outlet"
                                    onCloseComplete={() => {setCreateModal(false)}}
                                    shouldCloseOnOverlayClick={false}
                                    hasFooter={false}>

                                    <MDBCol md={12}>
                                        <CreateOutletModal modal={setCreateModal}/>
                                    </MDBCol>

                                </Dialog>

                                <Dialog
                                    isShown={editModal}
                                    title="Edit Outlet"
                                    onCloseComplete={() => {setEditModal(false)}}
                                    shouldCloseOnOverlayClick={false}
                                    hasFooter={false}>

                                    <MDBCol md={12}>
                                        <EditOutletModal editOutlet={editOutlet} modal={setEditModal}/>
                                    </MDBCol>

                                </Dialog>

                                <Modal title={selectedOutlet&&String(selectedOutlet.name).toUpperCase()}
                                       visible={isModalVisible}
                                       onCancel={toggle}
                                       width={window.innerWidth - 600}
                                       footer={false}>
                                    <ViewOutlet outlet={selectedOutlet}/>
                                </Modal>


                                <Card className="w-100">

                                    <MDBRow>
                                        <MDBCol md={12} className="w-100">
                                            <div className="text-left">
                                                <div className="d-block">
                                                    <h5 className="font-weight-bold">
                                                        <Text family='Nunito'>
                                                            Outlets
                                                        </Text>
                                                    </h5>
                                                </div>
                                            </div>

                                            <MDBRow className="ml-1">
                                                <SearchInput height={40} placeholder="Search outlets using name or location" className="w-100"
                                                             onChange={e => handleSearch(e.target.value)} />
                                                <Button height={40} appearance="primary" className="mx-2" onClick={() => {setCreateModal(true)}}>
                                                    New Outlet
                                                </Button>
                                            </MDBRow>
                                        </MDBCol>

                                    </MDBRow>

                                </Card>

                                <Card>
                                    {showAlert?
                                        <>
                                            <MDBAlert color={color} className="my-3 font-italic" >
                                                {message}
                                            </MDBAlert>
                                        </>
                                        : null }
                                    <Card className="d-flex flex-column">
                                        <>

                                            <MDBRow>
                                                <MDBCol md="4">
                                                    <Card className="scroll">
                                                        <div>
                                                            <List
                                                                itemLayout="vertical"
                                                                loading={loading}
                                                                //grid={{ gutter: 16, column: 4 }}
                                                                dataSource={dataArray}
                                                                renderItem={(outlet) => (
                                                                    <List.Item
                                                                        actions={[
                                                                            <MDBIcon icon="eye" size="lg" className="dark-grey-text" onClick={() => {
                                                                                showViewModal(outlet)
                                                                            }}/>,
                                                                            <MDBIcon icon="edit" size="lg" className="blue-text" onClick={() => {
                                                                                showEditModal(outlet);
                                                                            }}/>,
                                                                            <MDBIcon icon="trash" size="lg" className="red-text" onClick={() => {
                                                                                // eslint-disable-next-line no-restricted-globals
                                                                                if (confirm("Are you sure you want to delete outlet?")) {
                                                                                    deleteOutlet(outlet.outletID);
                                                                                }
                                                                            }}/>
                                                                        ]}
                                                                    >

                                                                        <List.Item.Meta
                                                                            //avatar={<Avatar src={outlet.avatar} />}
                                                                            title={<a>{outlet.name}</a>}
                                                                            description={`${outlet.district}, ${outlet.area}`}
                                                                        />
                                                                        <div className="d-flex flex-column w-100">
                                                                            <div> <>Products : </> <b>{Object.values(outlet.products).length}</b></div>
                                                                            <div> <>By : </><b>{userArray[userArray.findIndex(x => (x.userID) === outlet.createdByID)]&&
                                                                            userArray[userArray.findIndex(x => (x.userID) === outlet.createdByID)].firstname + " " +
                                                                            userArray[userArray.findIndex(x => (x.userID) === outlet.createdByID)].surname}</b>
                                                                                </div>
                                                                        </div>


                                                                    </List.Item>
                                                                )}
                                                            />

                                                        </div>
                                                    </Card>
                                                </MDBCol>

                                                <MDBCol md="8">
                                                    <MDBCard >
                                                        <Map geoArray={geoArray} modal={showViewModal}
                                                        />
                                                    </MDBCard>

                                                </MDBCol>
                                            </MDBRow>
                                        </>
                                    </Card>
                                </Card>

                            </MDBCol>
                        </MDBRow>
                    </Content>
                </Layout>
            </Layout>

        </div>
    )
}

export  default Outlets;
